<div class="mainColumn">

	<div class="theCard">

		<div class="theLogo">

			<a
				[routerLink]="['/auth/login']"
				title="Startseite"
			>
				<img
					[src]="logoSrc || 'assets/logo.png'"
				style="max-width: 100%; margin: 0 0 2em 0; mix-blend-mode: darken;"
				>
			</a>

		</div>

		<form [formGroup]="changeForgotPasswordForm" style="max-width: 30em; margin: 2em 0">

			<mat-form-field style="width: 100%;">

				<input matInput
						placeholder="Neues Passwort"
						formControlName="newPassword"
						[type]="hideNewPassword ? 'password' : 'text'"
						autocomplete="new-password">
				<mat-icon matSuffix style="cursor:pointer" (click)="hideNewPassword = !hideNewPassword">
					{{hideNewPassword ? 'visibility' : 'visibility_off'}}
				</mat-icon>

				<mat-error *ngIf="changeForgotPasswordForm.controls['newPassword'].hasError('required')">
					Please enter a new password
				</mat-error>

			</mat-form-field>

			<mat-form-field style="width: 100%;">
				<input matInput
						placeholder="Passwort Bestätigung"
						formControlName="newPasswordConfirm"
						[type]="hideNewPassword ? 'password' : 'text'"
						autocomplete="new-password">
				<mat-icon matSuffix style="cursor:pointer" (click)="hideNewPassword = !hideNewPassword">
					{{hideNewPassword ? 'visibility' : 'visibility_off'}}
				</mat-icon>

				<mat-error *ngIf="changeForgotPasswordForm.controls['newPasswordConfirm'].hasError('required')">
					Please confirm your new password
				</mat-error>
			</mat-form-field>

			<!-- <re-captcha
			(resolved)="captchaResolved($event)"
			siteKey="{{recaptchaKey}}"
			#captchaRef="reCaptcha"
			></re-captcha> -->

			<p style="text-align: left;">
				Ein sicheres Passwort enthält 12 Zeichen, 1 Zahl,
				1 Symbol (!"#$%&'*+,-./:;=?&#64;[]\^_`|~),
				1 Großbuchstaben und 1 Kleinbuchstaben
			</p>
			<ul style="text-align: left;">
				<li [ngClass]="{'red': !isZeile1(), 'green': isZeile1()}">Passwort besteht aus mindestens 12 Zeichen</li>
				<li [ngClass]="{'red': !isZeile2(), 'green': isZeile2()}">Passwort enthält Großbuchstaben</li>
				<li [ngClass]="{'red': !isZeile3(), 'green': isZeile3()}">Passwort enthält Kleinbuchstaben</li>
				<li [ngClass]="{'red': !isZeile4(), 'green': isZeile4()}">Passwort enthält Sondernzeichen</li>
				<li [ngClass]="{'red': !isZeile5(), 'green': isZeile5()}">Passwort enthält Ziffern</li>
				<li [ngClass]="{'red': !isZeile6(), 'green': isZeile6()}">Passwörter stimmen überein</li>
			</ul>

			<button
				mat-raised-button color="primary"
				[disabled]="!canSubmit"
				(click)="changePassword()"
			>
				Speichern
			</button>

		</form>

	</div>

</div>
